import { Pipe, PipeTransform } from "@angular/core";
import { hexIsLight } from "../../helpers/helpers";

@Pipe({
    name: 'hexIsLight',
    standalone: true
})
export class HexIsLightPipe implements PipeTransform {
  transform(color: string): boolean {
    return hexIsLight(color)
  }
}